<div class="call-history-filters">
  <form [formGroup]="form">
    <div
      class="call-history-filters__row"
      *ngFor="let filter of usedFilters">
      <!-- Remove button -->
      <div class="call-history-filters__remove">
        <button
          class="vox-btn call-history-filters__remove-btn"
          [disabled]="filter.unremovable"
          (click)="removeFilter(filter)">
          -
        </button>
      </div>
      <div class="call-history-filters__filter">
        <!-- Filter Selector -->
        <div
          ngbDropdown
          class="call-history-filters__dropdown vox-dropdown-input">
          <button
            class="call-history-filters__dropdown-toggle"
            [disabled]="filter.unremovable"
            ngbDropdownToggle>
            {{ "events.company-call-history.filters." + filter.name | Translate }}
          </button>
          <ul
            class="call-history-filters__dropdown-menu"
            ngbDropdownMenu>
            <li
              class="call-history-filters__dropdown-item dropdown-item"
              (click)="swapFilter(filter, uFilter)"
              ngbDrodownItem
              *ngFor="let uFilter of unusedFilters">
              {{ "events.company-call-history.filters." + uFilter.name | Translate }}
            </li>
          </ul>
        </div>
        <!-- Filter body -->
        <div class="call-history-filters__body">
          <ng-container [ngSwitch]="filter.type">
            <ng-container *ngSwitchCase="FilterType.DATE_TIME">
              <app-filter-date-time-range [formControl]="form.controls[filter.name]"></app-filter-date-time-range>
            </ng-container>

            <ng-container *ngSwitchCase="FilterType.TEXT">
              <app-filter-text
                [placeholder]="
                  (filter.name.includes('number')
                    ? 'events.company-call-history.filters.number-placeholder'
                    : 'events.company-call-history.filters.name-placeholder'
                  ) | Translate
                "
                [formControl]="form.controls[filter.name]"></app-filter-text>
            </ng-container>

            <ng-container *ngSwitchCase="FilterType.INTERVAL">
              <app-filter-interval
                [formControl]="form.controls[filter.name]"
                [unit]="filter.unit"></app-filter-interval>
            </ng-container>

            <ng-container *ngSwitchCase="FilterType.DROPDOWN">
              <app-filter-dropdown
                [formControl]="form.controls[filter.name]"
                [options]="filter.options"></app-filter-dropdown>
            </ng-container>

            <ng-container *ngSwitchCase="FilterType.TIMEZONE">
              <div class="call-history-filters__body-sizer">
                <vox-timezone-input
                  [dense]="true"
                  [formControl]="form.controls[filter.name]"></vox-timezone-input>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="FilterType.DID">
              <app-filter-did [formControl]="form.controls[filter.name]"></app-filter-did>
            </ng-container>

            <ng-container *ngSwitchCase="FilterType.USER">
              <app-filter-users [formControl]="form.controls[filter.name]"></app-filter-users>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </form>
  <div class="call-history-filters__row call-history-filters__actions">
    <div class="call-history-filters__add">
      <button
        class="vox-btn call-history-filters__add-btn"
        [disabled]="unusedFilters.length === 0"
        (click)="addFirstFilter()">
        +
      </button>
    </div>
    <div class="call-history-filters__apply">
      <button
        type="button"
        class="vox-btn vox-btn-secondary call-history-filters__apply-btn"
        (click)="formSubmit()">
        {{ "events.company-call-history.filters.apply" | Translate }}
      </button>
    </div>
    <div class="call-history-filters__clear">
      <button
        type="button"
        class="call-history-filters__clear-btn"
        (click)="formClear()">
        {{ "events.company-call-history.filters.clear" | Translate }}
      </button>
    </div>
  </div>
</div>
